'use client'

import React from 'react'
import { Section } from '@/components/Section'
import type { Project } from '@/payload-types'
import { Eyebrow } from '@/components/Eyebrow'
import { ProjectCard } from '@/components/ProjectCard'
import { ProjectCardLarge } from '@/components/ProjectCardLarge'

type ProjectSpotlightClientProps = {
  projects: Project[]
}

export function ProjectSpotlightClient({ projects }: ProjectSpotlightClientProps) {
  if (!projects || projects.length === 0) {
    return null
  }

  return (
    <Section bgClassName="bg-olive-2">
      <div className="flex flex-col xl:flex-row gap-[50px]">
        <div className="flex-6">
          <div className="flex flex-col gap-[50px]">
            <Eyebrow variant="light" label="Project Spotlight" color="highlighter" />
            <ProjectCardLarge
              size="lg"
              project={projects[0]!}
              className="w-full"
              card={false}
              aspectRatio="2/1"
              showAuthor
              variant="light"
            />
          </div>
        </div>
        <div className="w-[2px] border border-olive-1" />
        <div className="flex-3">
          <div className="flex flex-col gap-[50px]">
            <Eyebrow variant="light" label="Featured Tools" color="zest" />
            <div className="flex flex-col gap-[50px]">
              {projects.slice(1, 4).map((project) => (
                <div key={project.id} className="">
                  <ProjectCard
                    project={project}
                    variant="light"
                    aspectRatio="3/4"
                    imageClassName="w-full h-[200px] md:w-[120px] md:h-auto"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Section>
  )
}
